import { render } from "./PartnerTwo.vue?vue&type=template&id=3d9cbd58"
import script from "./PartnerTwo.vue?vue&type=script&lang=js"
export * from "./PartnerTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__